<template>
  <div class="ccui-app-iframe-no-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-no-operate-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">
              发布分包商澄清
            </el-button>
          </div>
          <div class="fr">
            <el-button type="single-number" plain @click="addNew"
              >新增</el-button
            >
          </div>
          <div class="clearfix"></div>
        </div>
        <!--        <el-tabs class="el-tabs__customize">-->
        <!--          <el-tab-pane label="发布分包商澄清">-->
        <!--            <div class="fr">-->
        <!--              <el-button type="single-number" plain @click="addNew"-->
        <!--                >新增</el-button-->
        <!--              >-->
        <!--            </div>-->
        <!--            <div class="clearfix"></div>-->
        <!--            <br />-->
        <el-table :data="tableData" border @row-dblclick="viewDetails">
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="supName"
            label="分包商"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
          <el-table-column
            property="noticeTitle"
            label="标题"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="viewDetails(row)">{{
                row.noticeTitle
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            property="noticeStartTime"
            label="澄清通知发送时间"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
          <el-table-column
            property="noticeEndTimeEnd"
            label="澄清结束时间"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
          <el-table-column
            property="createName"
            :label="
              `${
                purchaseType == 1 ||
                purchaseType == 4 ||
                purchaseType == 7 ||
                purchaseType == 8
                  ? '评审'
                  : '评标'
              }专家`
            "
            show-overflow-tooltip
            width="120"
          ></el-table-column>
          <el-table-column
            property="noticeStatusStr"
            label="公告状态"
            show-overflow-tooltip
            width="120"
          ></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button
                :disabled="row.noticeStatus != '0'"
                type="text"
                @click="editNotice(row)"
                >编辑</el-button
              >
              <el-button type="text" @click="viewDetails(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--          </el-tab-pane>-->
        <!--        </el-tabs>-->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import { scpQrySupClearNoticeListApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
export default {
  name: "subIssueClarificationNotice",
  components: {
    breadcrumbSourcing
  },
  data() {
    return {
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType, // 招标方式
      breadcrumbData: {
        titname: "发布分包商澄清"
      },
      tableData: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      scpQrySupClearNoticeListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        noticeStatuss: ["0", "1"]
      }).then(res => {
        res.data.data.forEach(item => {
          switch (item.noticeStatus) {
            case "0":
              item.noticeStatusStr = "编辑中";
              break;
            case "1":
              item.noticeStatusStr = "已发布";
              break;
            case "2":
              item.noticeStatusStr = "已澄清";
              break;
            case "3":
              item.noticeStatusStr = "未澄清";
              break;
            default:
              break;
          }
        });
        this.tableData = res.data.data;
      });
    },
    editNotice(row) {
      this.$router.push({
        name: "scpAddIssueClarificationNotice",
        query: {
          type: 3, // 0：发布澄清通知 1：查看澄清通知 2：查看澄清函内容 3:编辑澄清通知
          noticeId: row.noticeId,
          supName: row.supName,
          supCode: row.supCode,
          supJoinId: row.supJoinId
        }
      });
    },
    viewDetails(row, column, e) {
      this.$router.push({
        name: "scpAddIssueClarificationNotice",
        query: {
          type: 1, // 0：发布澄清通知 1：查看澄清通知 2：查看澄清函内容 3:编辑澄清通知
          noticeId: row.noticeId,
          supName: row.supName
        }
      });
    },
    addNew() {
      this.$router.push({
        name: "scpAddIssueClarificationNotice",
        query: {
          type: 0, // 0：发布澄清通知 1：查看澄清通知 2：查看澄清函内容
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
</style>
